import { IRawHotel } from "../types/IRawHotel";
import { RenovationType } from "../types/IHotel";
const getRenovationTypes = (hotel: IRawHotel): RenovationType[] => {
    if(!hotel.builtDate && !hotel.renovationDate) return [];
    const currentYear = new Date().getFullYear();
    const result: RenovationType[] = [];
    if(hotel.builtDate && currentYear - hotel.builtDate <= 5) {
        result.push(RenovationType.RecentlyOpened);
    }

    if(hotel.renovationDate && currentYear - hotel.renovationDate <= 5) {
        result.push(RenovationType.FreshRenovation);
    }

    return result;
}

export default getRenovationTypes;